const initDeliveryInfo = {
  fullAddress: "",
  shortAddress: "",
  coordinates: [],
  courierId: "",

  apartment: "",
  mailIndex: "",
  entrance: "",
  floor: "",
  intercom: "",
  comment: "",
}
const initPickupPointsInfo = {};

export const state = () => ({
  selectedDeliveryMethods: [
    {
      value: "pickup",
      label: "Самовывоз"
    },
    {
      value: "delivery",
      label: "Доставка"
    },
  ],
  excludedClassesPickup: [],

  checkoutData: {},
  deliveryInfo: {...initDeliveryInfo},
  userInfo: {
    "name": "",
    "phone": "",
    "is_marketing": true
  },
  pickupPoints: [],
  pickupPointsInfo: {...initPickupPointsInfo},
  popUpConfirmNotifyMessage: null,
  isPopUpConfirmNotifyMessage: false,

  saveDeliveryInfo: {},
  savePickupPointsInfo: {},
  saveSelectedDeliveryMethod: "",

  selectedDeliveryMethod: "pickup", // pickup - Самовывоз; delivery - Курьер;
  selectedPayment: "",
  selectedDeliveryClass: "",

  promoInformation: {},
  certificateInformation: {},

  useActiveBonuses: 0,

  isLoadDeliveryCalculate: false,
  isOpenPopUpSelectAddress: false,
  isLoadingValidationAddressMap: false,
  isLoadPickupPoints: true,

  bonusesAccrued: 0,
  bonusesCartItems: [],
  isLoadBonusesAccrued: true,

  userAddresses: [],
  isLoadUserAddresses: true,
})

export const mutations = {
  changeSelectedDeliveryMethod: function (state, method) {
    state.selectedDeliveryMethod = method;
  },
  changeSelectedPayment: function (state, method) {
    state.selectedPayment = method;
  },
  changeOpenPopUpSelectAddress: function (state, open) {
    state.isOpenPopUpSelectAddress = open;

    if (!!open) {
      state.saveDeliveryInfo = {...state.deliveryInfo};
      state.savePickupPointsInfo = {...state.pickupPointsInfo};
      state.saveSelectedDeliveryMethod = state.selectedDeliveryMethod;

      state.deliveryInfo = {...initDeliveryInfo};
      state.pickupPointsInfo = {...initPickupPointsInfo};
    }
  },
  closePopUpSelectAddressReset: function (state, params) {
    state.deliveryInfo = {...state.saveDeliveryInfo};
    state.pickupPointsInfo = {...state.savePickupPointsInfo};
    state.selectedDeliveryMethod = state.saveSelectedDeliveryMethod;

    state.saveDeliveryInfo = {};
    state.savePickupPointsInfo = {};

    state.isOpenPopUpSelectAddress = false;
  },
  changeDeliveryInfo: function (state, deliveryInfo) {
    state.deliveryInfo = deliveryInfo;
  },
  changeSelectedDeliveryClass: function (state, val) {
    state.selectedDeliveryClass = val;
  },
  changeExcludedClassesPickup: function (state, className) {
    let excludedClassesPickup = [...state.excludedClassesPickup];
    let classIndex = excludedClassesPickup.findIndex((t) => t === className);
    if (classIndex > -1) {
      excludedClassesPickup.splice(classIndex, 1)
    } else {
      excludedClassesPickup.push(className)
    }
    state.excludedClassesPickup = excludedClassesPickup;
  },
  changePickupPointsInfo: function (state, pickupPointsInfo) {
    state.pickupPointsInfo = pickupPointsInfo;
  },
  changePromoInformation: function (state, promoInformation) {
    state.promoInformation = promoInformation;
  },
  changeCertificateInformation: function (state, certificateInformation) {
    state.certificateInformation = certificateInformation;
  },
  changeUserInfo: function (state, userInfo) {
    state.userInfo = userInfo;
  },
  changeLoadingValidationAddressMap: function (state, isLoadingValidationAddressMap) {
    state.isLoadingValidationAddressMap = isLoadingValidationAddressMap;
  },
  changeLoadDeliveryCalculate: function (state, isLoadDeliveryCalculate) {
    state.isLoadDeliveryCalculate = isLoadDeliveryCalculate;
  },
  changeUseActiveBonuses: function (state, useActiveBonuses) {
    state.useActiveBonuses = useActiveBonuses;
  },

  setCheckoutData: function (state, checkoutData) {
    state.checkoutData = checkoutData;
  },
  setPickupPoints: function (state, pickupPoints) {
    state.pickupPoints = pickupPoints;
    state.isLoadPickupPoints = false;
  },
  setPopUpConfirmNotifyMessage: function (state, val) {
    state.popUpConfirmNotifyMessage = val;
  },
  setIsPopUpConfirmNotifyMessage: function (state, val) {
    state.isPopUpConfirmNotifyMessage = val;
  },

  resetDeliveryInfo: function (state) {
    state.deliveryInfo = {...initDeliveryInfo};
  },
  resetPickupPointsInfo: function (state) {
    state.pickupPointsInfo = {...initPickupPointsInfo};
  },

  changeBonusesAccrued: function (state, val) {
    state.bonusesAccrued = val;
  },
  changeBonusesCartItems: function (state, val) {
    state.bonusesCartItems = val;
  },
  changeLoadBonusesAccrued: function (state, val) {
    state.isLoadBonusesAccrued = val;
  },

  setUserAddresses: function (state, val) {
    state.userAddresses = val;
    state.isLoadUserAddresses = false;
  },
  setDataFromCreateRepeatOrder: function (state, data) {
    state.userInfo = data?.userInfo || state?.userInfo;
    state.deliveryInfo = data?.deliveryInfo || state?.deliveryInfo;
    state.selectedPayment = data?.selectedPayment || state?.selectedPayment;
    state.pickupPointsInfo = data?.pickupPointsInfo || state?.pickupPointsInfo;
    state.selectedDeliveryMethod = data?.selectedDeliveryMethod || state?.selectedDeliveryMethod;
  },
}

export const actions = {
  getCheckoutData: async function ({commit}) {
    const response = await this.$api.agent.transport.get('/checkout/data').then((res) => {
      return res.data
    }).catch(() => {
      return {}
    });
    commit("setCheckoutData", response);
  },
  getPickupPoints: async function ({commit}) {
    const response = await this.$api.agent.transport.get(`/checkout/pickup-points`).then((res) => {
      return res.data
    }).catch(() => {
      return {}
    });
    commit("setPickupPoints", response)
  },

  getUserAddresses: async function ({commit}) {
    const res = await this.$api.agent.transport.get(`/user/addresses`)
      .then((res) => {
        return res?.data || []
      })
      .catch(() => {
        return []
      })
    commit("setUserAddresses", res);
  },
  removeUserAddress: async function (params, addressId) {
    const isSuccess = await this.$api.agent.transport.delete(`/user/addresses/${addressId}`)
      .then(() => true)
      .catch(() => false)
    if (!isSuccess) {
      return isSuccess
    }

    await params.dispatch('getUserAddresses');

    return true
  },
  setUserAddressPickup: async function (params, address) {
    const pointCode = String(address?.delivery_data?.place_id || address?.delivery_data?.shop_id);
    const pickupPoint = [...(this.state["cart-new"]?.pickupPoints || [])].find((t) => Boolean(String(t.class) === String(address?.classPoint?.class)));
    const itemPoint = [...(pickupPoint?.points || [])].find((point) => Boolean(String(point.code) === String(pointCode)));

    if (!itemPoint) {
      return {
        error: 'Данный адрес недоступен и удалён из списка. Выберите другой.'
      }
    }

    const pickupPoints = {
      point: {
        lat: address.lat,
        lon: address.lon,
        type: itemPoint.type,
        phones: itemPoint.phones,
        classPoint: address.classPoint,
        address: address.computed_address,
        pickup_type: itemPoint.pickup_type,
        code: address.delivery_data?.place_id || address.delivery_data?.shop_id,
      }
    };
    params.commit('changePickupPointsInfo', pickupPoints)
  },
  setUserAddressCourier: async function (params, address) {
    params.commit("changeSelectedDeliveryMethod", "delivery");
    const _coordinates = [address?.lat, address?.lon];
    const _deliveryInfo = {
      ...this.deliveryInfo,
      apartment: address?.flat,
      mailIndex: address?.zip,
      entrance: address?.entrance,
      floor: address?.floor,
      intercom: address?.intercom,

      courierId: address.courierId,
      fullAddress: address.computed_address,
      shortAddress: address.computed_address,
      coordinates: _coordinates
    };
    params.commit("changeDeliveryInfo", _deliveryInfo);
  },

  getDeliveryCalculate: async function (context, params) {
    const selectedCourierId = context?.state?.deliveryInfo?.courierId;
    const selectedCourier = (context?.state?.checkoutData?.deliveries || []).find((t) => Boolean(String(t?.id) === String(selectedCourierId)));

    let body = {
      zip: params.zip,
      address: [params?.cityName, params?.address].filter((t) => !!t).join(" "),
      destination_address: [params?.cityName, params?.address].filter((t) => !!t).join(" "),
      city_id: context?.rootState?.appState?.config?.city?.model?.cdek_id,
    };
    let actionUrl = `/checkout/delivery/${selectedCourierId}/calculate`;

    // Срочная доставка яндекса
    if (selectedCourier?.class === "yandex-day-delivery") {
      body.coordinates = [...(params?.coordinates || [])].reverse();
      body.address = params.fullAddress || params.address;

      actionUrl = `/checkout/delivery/${selectedCourierId}/estimate`
    }


    context.commit("changeLoadDeliveryCalculate", true);
    const response = await this.$api.agent.transport.post(actionUrl, body).then((res) => {
      return res.data
    }).catch((err) => {
      if (err?.response?.status === 400) {
        return {error: err?.response?.data?.message || "Выбранный способ доставки не доступен по вашему адресу"}
      }
      return {error: "Выбранный способ доставки не доступен по вашему адресу"}
    });
    if (response?.error) {
      context.commit("changeLoadDeliveryCalculate", false);
      return response
    }
    if (!!response) {
      let checkoutData = {...(context?.state?.checkoutData || {})};
      let deliveries = [...(checkoutData.deliveries || [])];
      let deliveryIndex = deliveries.findIndex((t) => Boolean(String(t.class) === String(selectedCourier?.class)));
      let delivery = deliveries[deliveryIndex];
      deliveries[deliveryIndex] = {
        ...delivery,
        term: response?.term || delivery?.term || null,
        cost: response?.cost || delivery?.cost || null,
        termLabel: response?.termLabel || null,
      }
      checkoutData.deliveries = deliveries;
      context.commit("setCheckoutData", checkoutData);
    }

    context.commit("changeLoadDeliveryCalculate", false);

    return response
  },


  getBonusesAccrued: async function ({commit}) {
    commit("changeLoadBonusesAccrued", true);
    const cartItems = await this.$api.agent.transport.get('/bonuses/bonuses').then((res) => {
      return res.data?.cart_items || []
    }).catch(() => {
      return []
    });

    const total = cartItems.reduce((val, cartItem) => {
      return val + (cartItem?.bonuses || 0)
    }, 0);

    commit("changeBonusesAccrued", total);
    commit("changeBonusesCartItems", cartItems);
    commit("changeLoadBonusesAccrued", false);
  },

  createRepeatOrder: async function (params, order) {

    // Добавление товаров в корзину
    const itemsProducts = order?.items || [];
    let messages = [];
    for (const orderItem of itemsProducts) {
      const product = orderItem?.product;
      const quantity = orderItem?.quantity || 1;
      const bodyAddProduct = {
        "product_id": product?.id,
        "modification_id": orderItem?.modification_id,
        "quantity": quantity,
        "data": orderItem?.data,
        "options": orderItem?.options
      };
      const isSuccess = await this.$api.agent.transport.post("/cart", bodyAddProduct)
        .then(() => true)
        .catch(() => false);

      let _message = `Товар ${ orderItem?.product_name } добавлен в кол-ве ${ quantity } шт.`;
      if (!isSuccess) {
        _message = `Мы не смогли добавить товар ${ orderItem?.product_name }`
      }
      messages.push(_message)
    }

    // Предустановка данных пользователя из заказа
    await params.dispatch("getCheckoutData");
    await params.dispatch("getPickupPoints");
    const payments = this.state["cart-new"]?.checkoutData?.payments || [];
    const deliveries = this.state["cart-new"]?.checkoutData?.deliveries || [];
    const delivery = deliveries.find((t) => String(t?.id) === String(order?.delivery_method_id));

    const userInfo = {
      name: order?.customer_name,
      email: order?.customer_email,
      phone: order?.customer_phone,
    };
    const selectedPayment = payments.find((t) => Boolean(String(t?.name) === String(order?.payment_method_name)))?.class;

    const isDeliveryCourier = Boolean(delivery?.type === "courier");
    if (isDeliveryCourier) {
      const deliveryInfo = {
        "fullAddress": order?.delivery_address || "",
        "shortAddress": order?.delivery_address || "",
        "coordinates": [60.617112, 56.850624],
        "courierId": order?.delivery_method_id,
        "apartment": order?.address?.flat,
        "mailIndex": order?.address?.zip,
        "entrance": order?.address?.entrance,
        "floor": order?.address?.floor,
        "intercom": order?.address?.intercom,
        "comment": order?.address?.comment
      };
      const selectedDeliveryMethod = "delivery";
      params.commit("setDataFromCreateRepeatOrder", {
        userInfo,
        deliveryInfo,
        selectedPayment,
        selectedDeliveryMethod,
      });
    } else {
      await params.dispatch("getPickupPoints");
      const deliveryClass = deliveries.find((t) => Boolean(String(t?.id) === String(order?.delivery_method_id)));
      const pickupPoint = (this.state["cart-new"]?.pickupPoints || []).find((t) => Boolean(String(t?.id) === String(deliveryClass?.id)));
      const point = (pickupPoint?.points || []).find((t) => Boolean(String(t.address) === String(order?.delivery_address)));
      const pickupPointsInfo = {
        point: {
          ...point,
          classPoint: deliveryClass
        }
      };
      const selectedDeliveryMethod = "pickup";
      params.commit("setDataFromCreateRepeatOrder", {
        userInfo,
        selectedPayment,
        pickupPointsInfo,
        selectedDeliveryMethod,
      });
    }


    return messages
  }
}
